//
// Intercept HTTP requests to automatically inject a JWT into the "Authorization: Bearer" header.
//
// Taken from https://medium.com/@ryanchenkie_40935/angular-authentication-using-the-http-client-and-http-interceptors-2f9d1540eb8
//
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SpinnerService } from '@chevtek/angular-spinners';
import 'rxjs/add/operator/do';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../service/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService, private spinnerService: SpinnerService) {}

  private pendingRequests = 0;

  private showLoading = false;

  private spinnerTimeout;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.turnOnModal();

    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.auth.getToken()}`,
      },
    });
    return next.handle(request).do(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.turnOffModal();
        }
      },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          this.turnOffModal();
        }
      }
    );
  }

  private turnOnModal() {
    this.pendingRequests++;
    if (!this.showLoading) {
      this.showLoading = true;
      this.spinnerTimeout = setTimeout(() => {
        return this.spinnerService.show('slowProcesses');
      }, 700);
    }
    this.showLoading = true;
  }

  private turnOffModal() {
    this.pendingRequests--;
    if (this.pendingRequests <= 0) {
      clearTimeout(this.spinnerTimeout);
      if (this.showLoading) {
        this.spinnerService.hide('slowProcesses');
      }
      this.showLoading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/token.interceptor.ts